import type { Experiment } from 'types';
import { resolveObjectives } from 'helpers/objectives';
import { metricLabel } from '@/state/experiments/report-summary';
import { deviceTag, websiteLabel } from '@/state/experiments/report-card';
import type { ReportContext } from './ReportForm';

/**
 * What the report card says about the experiment, read off the experiment the screen already has.
 * The metric is named as the Statistics tab names it: the mapped objective, or the generic
 * "Conversions" when the website has not mapped one, so the card never claims a mapping that
 * does not exist.
 */
export const buildContext = (experiment: Experiment): ReportContext => {
  const { primary, primaryIsDefault } = resolveObjectives(experiment);

  return {
    experimentId: experiment.id,
    experimentName: experiment.name,
    hypothesis: experiment.hypothesis ?? '',
    startsAt: experiment.startsAt ?? null,
    endsAt: experiment.endsAt ?? null,
    metric: primaryIsDefault ? 'Conversions' : metricLabel(primary),
    devices: deviceTag(experiment.deviceTargeting ?? []),
    website: websiteLabel(experiment.website?.url ?? experiment.websiteUrl),
  };
};
